import livePreview from '@teamnovu/statamic-live-preview-nuxt'

export default livePreview
